<template>
  <div id="mediaSearchBar" ref="mediaSearchBar" class="common-search">
    <div class="search-bar-content">
      <!-- Media Types -->
      <div class="media-types">
        <template v-for="(mediaType, index) in mediaTypes" :key="`mediaTypeFilterTooltip-${index}`">
          <el-tooltip
            :popper-class="'custom-tooltip-popper-filters'"
            :show-arrow="false"
            :content="mediaType.tName"
            effect="light"
            class="item"
            placement="bottom">
            <div @click="handleMediaTypeClick($event, mediaType.value)"
              :class="['icon file-type-search-option', mediaType.name, {'is-selected': selectedMediaTypes.includes(mediaType.value)}]">
            </div>
        </el-tooltip>
        </template>
      </div>

      <!-- Search Icon -->
      <div v-if="isSearchIconVisible" @click="handleSearchIconClick" class="search-icon show-search-options-action prevent-confirmed-search"></div>

       <!-- Search Input -->
      <div v-if="isSearchInputVisible" onclick="event.stopPropagation()" class="search-content unconfirmed-search prevent-confirmed-search">
        <el-input
          :model-value="searchTextVal"
          @update:model-value="newValue => searchTextVal = newValue"
          ref="mediaSearchInput"
          :placeholder="$t('label.search')"
          class="search-input">
        </el-input>
      </div>
    </div>
  </div>
</template>
<script src="./media-search-bar.js"></script>
<style lang="scss" src="./media-search-bar.scss"></style>
